import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { ProblemAgitation } from './components/ProblemAgitation';
import { ProductReveal } from './components/ProductReveal';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { ProtocoloPro } from './components/ProtocoloPro';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { Footer } from './components/Footer';
import { LiveNotification } from './components/LiveNotification';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  const testimonialsSet1 = [{
    quote: 'Lo imprimí y empezó a usarlo ese mismo día. Me emocioné cuando lo vi concentrado durante media hora.',
    author: 'Mariana G., hija',
    location: 'Buenos Aires'
  }, {
    quote: 'Mi mamá tiene 81 años y le encanta. Hace las actividades sola y después me cuenta todo lo que recordó.',
    author: 'Laura P., hija',
    location: 'Rosario'
  }, {
    quote: 'Le regalé el pack a mi papá y fue lo mejor que pude hacer. Lo tiene en la mesa del comedor y lo usa todos los días.',
    author: 'Roberto M., hijo',
    location: 'Córdoba'
  }];
  const testimonialsSet2 = [{
    quote: 'Mi papá tiene 79 años y lo primero que hace cuando se levanta es buscar el libro. Nunca pensé que iba a engancharse tanto.',
    author: 'Cecilia R.',
    location: 'Mendoza'
  }, {
    quote: 'El Protocolo Pro fue clave. Ahora llevo el registro al médico y el neurólogo me felicitó por el seguimiento.',
    author: 'Roberto M.',
    location: 'Buenos Aires'
  }, {
    quote: 'Le regalé el pack a mi abuela de 84 años. Hace las actividades sola, me llama para contarme los recuerdos que aparecieron y está más activa que nunca.',
    author: 'Sofía C.',
    location: 'La Plata'
  }, {
    quote: 'El Cuaderno de Recuerdos fue una excusa hermosa para hablar con mi mamá de cosas que nunca nos habíamos contado. Vale cada peso solo por eso.',
    author: 'Pablo A.',
    location: 'Neuquén'
  }];
  return <div className="min-h-screen bg-cream font-sans selection:bg-amber-200 selection:text-blue-900 pb-20 md:pb-0" data-id="element-0">
      <Hero data-id="element-1" />

      <Testimonials testimonials={testimonialsSet1} className="bg-cream -mt-8 relative z-20" data-id="element-2" />

      <ProblemAgitation data-id="element-3" />

      <ProductReveal data-id="element-4" />

      <Bonuses data-id="element-5" />

      <Pricing planAOriginal="$30.000" planAPrice="$19.990" planBOriginal="$50.000" planBPrice="$27.990" data-id="element-6" />

      <ProtocoloPro data-id="element-7" />

      <Testimonials title="❤️ MÁS FAMILIAS QUE YA LO TIENEN" testimonials={testimonialsSet2} className="bg-sand" data-id="element-8" />

      <Guarantee data-id="element-9" />

      <FAQ data-id="element-10" />

      <CostOfInaction data-id="element-11" />

      {/* Final CTA Block (Reusing Pricing) */}
      <Pricing planAOriginal="$39.000" planAPrice="$19.990" planBOriginal="$89.000" planBPrice="$27.990" data-id="element-12" />

      <Footer data-id="element-13" />

      <LiveNotification data-id="element-14" />
      <StickyCTA data-id="element-15" />
    </div>;
}